<script setup lang="ts">
import { MsgStatus } from '@/constants/accountCenter/message'
import { formatDate, setValue } from '@/utils/uCommonTs'

interface Props {
  list?: any[]
  type?: string
}
const { list, type } = defineProps<Props>()

const emit = defineEmits<Emits>()
interface Emits {
  (e: 'read', val: number, type?: number): void
}
</script>

<template>
  <n-scrollbar class="list-scrollbar" style="height: calc(100vh - 250px)">
    <n-list hoverable clickable>
      <template v-if="type === '站内通知'">
        <n-list-item v-for="(item) in list" :key="item.id" :class="{ 'opacity-30 pointer-events-none': item.readStatus === '1' }" @click="emit('read', item.id, type)">
          <n-thing content-indented>
            <template #header>
              <n-ellipsis :line-clamp="1">
                {{ item.title }}
              </n-ellipsis>
            </template>
            <template #avatar>
              <nova-icon icon="icon-park-outline:comment" :size="30" class="c-primary" />
            </template>
            <template v-if="item.type" #header-extra>
              <n-tag :bordered="false" size="small">
                {{ item.type }}
              </n-tag>
            </template>
            <template v-if="item.summary" #description>
              <n-ellipsis :line-clamp="2">
                {{ item.content }}
              </n-ellipsis>
            </template>
            <template #footer>
              {{ formatDate(item.createTime) }}
            </template>
          </n-thing>
        </n-list-item>
      </template>
      <template v-if="type === '会员公告'">
        <n-list-item v-for="(item) in list" :key="item.newsID" :class="{ 'opacity-30 pointer-events-none': item.newid !== null }" @click="emit('read', item.newsID, type)">
          <n-thing content-indented>
            <template #header>
              <n-ellipsis :line-clamp="1">
                {{ item.newsTitleCn }}
              </n-ellipsis>
            </template>
            <template #avatar>
              <nova-icon icon="icon-park-outline:message-emoji" :size="30" class="c-primary" />
            </template>
            <!-- <template v-if="item.type" #header-extra>
              <n-tag :bordered="false" size="small">
                {{ item.type }}
              </n-tag>
            </template> -->
            <template v-if="item.summary" #description>
              <n-ellipsis :line-clamp="2">
                {{ item.summary }}
              </n-ellipsis>
            </template>
            <template #footer>
              {{ formatDate(item.sendDate) }}
            </template>
          </n-thing>
        </n-list-item>
      </template>
      <template v-if="type === '待办事项'">
        <n-list-item v-for="(item) in list" :key="item.id" class="wait-item" @click="emit('read', item.id, type, item)">
          <n-thing content-indented>
            <template #header>
              <n-ellipsis :line-clamp="1">
                {{ item.title }}
              </n-ellipsis>
            </template>
            <template #avatar>
              <nova-icon icon="icon-park-outline:message-emoji" :size="30" class="c-primary" />
            </template>
            <template v-if="item.overdue" #header-extra>
              <n-tag :bordered="false" size="small">
                {{ setValue(MsgStatus, item.status, 'label') }}
              </n-tag>
            </template>
            <template #footer>
              <div class="flex justify-between">
                <span>{{ formatDate(item.createTime) }}</span>
                <!-- <n-button class="waitDoBtn" size="tiny" type="primary" @click.stop="emit('read', item.id, type)">
                  标为完成
                </n-button> -->
              </div>
            </template>
          </n-thing>
        </n-list-item>
      </template>
    </n-list>
  </n-scrollbar>
</template>

<style scoped lang="scss">
.wait-item{
   .waitDoBtn{
      display: none;
    }
  &:hover{
    .waitDoBtn{
      display: block;
    }
  }
}
</style>
